'use strict';
import $ = require('jquery');

export class healthTable {
    constructor() {
        if ($('.bulletHealthTable').length === 0) return;

        border();
        window.addEventListener('resize', border);
        function border() {
            $('.bulletHealthTable').each(function () {
                const parentWidth = $(this).css('width');
                const width = $(this).children('table').css('width');
                if (parentWidth === width) {
                    $(this).css('border', '0');
                }else{
                    $(this).css('border', '3px solid #000');
                }
            });
        }
    }
}

export default healthTable;